// src/utils/questionEngineRouteMeta.js
import { FLOW_SLUG_CONFIG } from './flowSlugConfig';
import { resolveQuestionSet } from '../experiments/flowVariants';

// Returns { flowSlug, category, product, stepIndexParam, questionSet }
// Expects step param in the form "step1", "step2", etc.
export const getRouteMeta = (props) => {
  const params = props.params || {};
  const locationState = props.location?.state || {};

  // Nested flows (e.g. business verticals under /business-insurance-quote/)
  // are matched by a route where :flowSlug only captures the last segment;
  // flowSlugPrefix supplies the static parent segment so the composite key
  // matches FLOW_SLUG_CONFIG and step navigation stays on the full path.
  const rawFlowSlug = params.flowSlug || null;
  const flowSlug =
    props.flowSlugPrefix && rawFlowSlug
      ? `${props.flowSlugPrefix}/${rawFlowSlug}`
      : rawFlowSlug;
  const stepRaw =
    params.step ||
    (typeof params.stepNumber === 'string'
      ? `step-${params.stepNumber}`
      : null);

  let stepIndexParam = null;
  if (typeof stepRaw === 'string') {
    const match = stepRaw.match(/^step-?(\d+)$/);
    if (match) {
      stepIndexParam = parseInt(match[1], 10);
    }
  }

  let category = locationState.category || null;
  let product = locationState.product || null;

  // If category/product are not in state, derive from slug mapping
  if ((!category || !product) && flowSlug && FLOW_SLUG_CONFIG[flowSlug]) {
    const cfg = FLOW_SLUG_CONFIG[flowSlug];
    category = category || cfg.category;
    product = product || cfg.product;
  }

  // The directory the questions load from. Normally `Category/Product`; a
  // flow experiment may point the same product at a sibling directory (see
  // experiments/flowVariants.js). Only the dynamic import in QuestionEngine
  // reads it.
  const questionSet =
    category && product
      ? resolveQuestionSet(category, product).questionSet
      : null;

  return {
    flowSlug,
    category,
    product,
    stepIndexParam,
    questionSet,
  };
};
